import React from 'react';

import CompanyTable from './CompanyTable';
import CompanyAccordion from './CompanyAccordion';

import Loading from './Loading';
import Error from './Error';
import CategoryFilter from './CategoryFilter';
import {apiBaseUrl} from './Config';

class CompanyView extends React.Component {
    constructor(props) {
	super(props);
	this.state = {
	    error: null,
	    isLoaded: false,
	    companies: [],
	    filterCategory: ""
	};

	this.resource = apiBaseUrl + "companies";

	this.handleFilterCategoryChange = this.handleFilterCategoryChange.bind(this);
    }

    componentDidMount() {
	fetch(this.resource, {
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Accept": "application/json"
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		return response.json()
	    })
	    .then((result) => {
		this.setState({
		    isLoaded: true,
		    companies: result
		});
	    })
	    .catch((error) => {
		this.setState({
		    isLoaded: true,
		    error
		});
	    })
    }

    handleFilterCategoryChange(event) {
	this.setState({
	    filterCategory: event.target.value
	});
    }
    
    render() {
	const { error, isLoaded, companies, filterCategory } = this.state;
	const rows = [];
	
	companies.forEach((company) => {
	    if (company.category.indexOf(filterCategory) === -1) {
		return;
	    }

	    rows.push(company);
	});
	
	if (error) {
	    return (
		<Error error={error} />
	    );
	} else if (!isLoaded) {
	    return (
		<Loading />
	    );
	} else {
	    return (
		<div className="content">
		    <CategoryFilter value={this.filterCategory}
				    token={this.props.token}
				    onHandleFilterCategoryChange={this.handleFilterCategoryChange}
				    onAuthError={this.props.onAuthError} />

		    <br />
		    
		    <div className="onlyshowmobile">
			<CompanyAccordion companies={rows} />
		    </div>
		    <div className="dontshowmobile">
			<CompanyTable companies={rows}/>
		    </div>
		</div>
	    );
	}
    }
}

export default CompanyView;
